/**
 * Created by Andrey Popov on 09.02.21.
 */

const FakeMerge = function (levelContent) {
    Merge2.current = this;

    this.counter = {
        isActive: function () {
            return true; 
        },
        registerStage: function () {},
        trigger: function () {},
        setTimeout: function () {}
    };

    this.levelContent = levelContent;

    Object.assign(this, {
        location: {},
        tutorial: {
            isActive: function () {}
        },
        energyLottery: {
            isAvailable: function () {
                return false; 
            },
            isReady: function () {
                return false; 
            }
        },
        spawn: function () {
            return [];
        },
        storeSave: function () {
        },
        on: function () {
        },
        thirdElementPlanner: {
            thirdElements: []
        },
        needToReplaceWithCoins: function () {
        },
        customers: {
            removeCustomer: function () {}
        }
    });
};

FakeMerge.prototype.stop = function () {
    if (this.stopped) {
        return;
    }
    this.stopped = true;
};

FakeMerge.prototype.on = function () {

};